import * as THREE from 'three'
import flattenDeep from 'lodash.flattendeep'

export let bell = []
export let snow = []
export let fireworks = []

export const Star = function() {
  const geo = new THREE.ConeGeometry(3, 10, 64)
  const place = new THREE.SphereGeometry(3, 32, 32)
  const mat = new THREE.MeshPhongMaterial({
    color: 0xe0bd21,
    emissive: 0x795da3,
    specular: 0xf66120,
    shininess: 10,
    flatShading: true,
    transparent: 1,
    opacity: 1
  })
  this.mesh = new THREE.Mesh(geo, mat)
  this.mesh.receiveShadow = true

  const leftTop = new THREE.Mesh(geo, mat)
  leftTop.receiveShadow = true
  leftTop.position.set(-5.5, -4, 0)
  leftTop.rotation.set(0, 0, THREE.Math.degToRad(75))

  const rightTop = new THREE.Mesh(geo, mat)
  rightTop.receiveShadow = true
  rightTop.position.set(5.5, -4, 0)
  rightTop.rotation.set(0, 0, THREE.Math.degToRad(-75))

  const leftBottom = new THREE.Mesh(geo, mat)
  leftBottom.receiveShadow = true
  leftBottom.position.set(-4, -10, 0)
  leftBottom.rotation.set(0, 0, THREE.Math.degToRad(140))

  const rightBottom = new THREE.Mesh(geo, mat)
  rightBottom.receiveShadow = true
  rightBottom.position.set(4, -10, 0)
  rightBottom.rotation.set(0, 0, THREE.Math.degToRad(-140))

  const placeHolder = new THREE.Mesh(place, mat)
  placeHolder.receiveShadow = true
  placeHolder.position.set(0, -5.75, 0)

  this.mesh.add(leftTop, rightTop, leftBottom, rightBottom, placeHolder)
}

export const Bready = function() {
  const geo = new THREE.SphereGeometry(4, 10, 32, 0, 5, 6, 6.3)
  const mat = new THREE.MeshPhongMaterial({
    color: 0xd09662,
    flatShading: true
  })
  this.mesh = new THREE.Mesh(geo, mat)
  this.mesh.castShadow = true

  const middleTop = new THREE.Mesh(geo, mat)
  // middleTop.castShadow = true
  middleTop.position.set(0, 0.8, 0)
  this.mesh.add(middleTop)

  const leftTop = new THREE.Mesh(geo, mat)
  // leftTop.castShadow = true
  leftTop.scale.set(0.8, 0.8, 0.8)
  leftTop.position.set(-3, 0.8, 0)
  this.mesh.add(leftTop)

  const leftBottom = new THREE.Mesh(geo, mat)
  // leftBottom.castShadow = true
  leftBottom.scale.set(0.8, 0.8, 0.8)
  leftBottom.position.set(-3, 0, 0)
  this.mesh.add(leftBottom)

  const rightTop = new THREE.Mesh(geo, mat)
  // rightTop.castShadow = true
  rightTop.scale.set(0.8, 0.8, 0.8)
  rightTop.position.set(3, 0.8, 0)
  this.mesh.add(rightTop)

  const rightBottom = new THREE.Mesh(geo, mat)
  // rightBottom.castShadow = true
  rightBottom.scale.set(0.8, 0.8, 0.8)
  rightBottom.position.set(3, 0, 0)
  this.mesh.add(rightBottom)

  const endTop = new THREE.Mesh(geo, mat)
  // endTop.castShadow = true
  endTop.scale.set(0.5, 0.5, 0.5)
  endTop.position.set(-6, 0.7, 0)
  this.mesh.add(endTop)

  const endBottom = new THREE.Mesh(geo, mat)
  // endBottom.castShadow = true
  endBottom.scale.set(0.5, 0.5, 0.5)
  endBottom.position.set(-6, 0, 0)
  this.mesh.add(endBottom)

  const beginTop = new THREE.Mesh(geo, mat)
  // beginTop.castShadow = true
  beginTop.scale.set(0.5, 0.5, 0.5)
  beginTop.position.set(6, 0.7, 0)
  this.mesh.add(beginTop)

  const beginBottom = new THREE.Mesh(geo, mat)
  // beginBottom.castShadow = true
  beginBottom.scale.set(0.5, 0.5, 0.5)
  beginBottom.position.set(6, 0, 0)
  this.mesh.add(beginBottom)
}

export const Bam = function() {
  const geo = new THREE.BoxGeometry(10, 10, 10)
  const mat = new THREE.MeshPhongMaterial({
    color: 0xfc6501,
    flatShading: true
  })
  this.mesh = new THREE.Mesh(geo, mat)
  this.mesh.castShadow = true
  this.mesh.receiveShadow = true

  const geometry = new THREE.CylinderGeometry(1, 8, 4, 4)
  const material = new THREE.MeshPhongMaterial({
    color: 0x017e00,
    flatShading: true
  })
  const roof = new THREE.Mesh(geometry, material)
  roof.castShadow = true
  roof.receiveShadow = true
  roof.position.set(0, 7, 0)
  roof.rotation.set(0, THREE.Math.degToRad(45), 0)
  this.mesh.add(roof)

  const geoDoor = new THREE.BoxGeometry(4, 2, 1)
  const door = new THREE.Mesh(geoDoor, material)
  door.castShadow = true
  door.receiveShadow = true
  door.position.set(-2, -2, 5)
  door.rotation.set(0, 0, THREE.Math.degToRad(90))
  this.mesh.add(door)
}

export const Trophee = function() {
  const geometry = new THREE.BoxGeometry(8, 3, 8)
  const material = new THREE.MeshPhongMaterial({
    color: 0x7c4800,
    flatShading: true
  })
  this.mesh = new THREE.Mesh(geometry, material)
  this.mesh.castShadow = true
  this.mesh.receiveShadow = true

  const geo = new THREE.CylinderGeometry(0.5, 1, 8, 40)
  const mat = new THREE.MeshPhongMaterial({
    color: 0x795da3,
    emissive: 0x71b8c6,
    specular: 0xf66120,
    shininess: 10,
    flatShading: true,
    transparent: 1,
    opacity: 1
  })
  const cyl = new THREE.Mesh(geo, mat)
  cyl.castShadow = true
  cyl.receiveShadow = true
  cyl.position.set(0, 3, 0)
  this.mesh.add(cyl)

  let points = []
  for (var i = 0; i < 10; i++) {
    points.push(new THREE.Vector2(Math.sin(i * 0.2) * 10 + 5, (i - 5) * 2))
  }

  const geom = new THREE.LatheGeometry(points, 30, 0, 6.3)
  const cup = new THREE.Mesh(geom, mat)
  // cup.castShadow = true
  cup.receiveShadow = true
  cup.scale.set(0.4, 0.4, 0.4)
  cup.position.set(0, 11, 0)
  this.mesh.add(cup)

  const earGeo = new THREE.TorusGeometry(2, 0.5, 30, 200, 3.9)
  const ear = new THREE.Mesh(earGeo, mat)
  // ear.castShadow = true
  ear.receiveShadow = true
  ear.position.set(4, 10, 2)
  ear.rotation.set(0, 0, THREE.Math.degToRad(-145))
  this.mesh.add(ear)

  const left = new THREE.Mesh(earGeo, mat)
  // left.castShadow = true
  left.receiveShadow = true
  left.position.set(-4, 10, 2)
  left.rotation.set(0, 0, THREE.Math.degToRad(100))
  this.mesh.add(left)
}

export const AkzoNobel = function() {
  const geometry = new THREE.CylinderGeometry(0.5, 1, 12, 40)
  const material = new THREE.MeshPhongMaterial({
    color: 0x7c4800,
    flatShading: true
  })
  this.mesh = new THREE.Mesh(geometry, material)
  this.mesh.castShadow = true
  this.mesh.receiveShadow = true

  const geo = new THREE.BoxGeometry(8, 2, 2)
  const top = new THREE.Mesh(geo, material)
  top.castShadow = true
  top.receiveShadow = true
  top.position.set(0, -4, 0)
  top.rotation.set(0, THREE.Math.degToRad(45), 0)
  this.mesh.add(top)

  const geom = new THREE.BoxGeometry(8, 1, 2)
  const mat = new THREE.MeshPhongMaterial({
    color: 0xa0a0a0,
    flatShading: true
  })
  const middle = new THREE.Mesh(geom, mat)
  middle.castShadow = true
  middle.receiveShadow = true
  middle.position.set(0, -5.5, 0)
  middle.rotation.set(0, THREE.Math.degToRad(45), 0)
  this.mesh.add(middle)

  const box = new THREE.BoxGeometry(8, 5, 2)
  const black = new THREE.MeshPhongMaterial({
    color: 0x000000,
    emissive: 0x000000,
    specular: 0xffed22,
    shininess: 10,
    flatShading: true,
    transparent: 1,
    opacity: 1
  })
  const bottom = new THREE.Mesh(box, black)
  bottom.castShadow = true
  bottom.receiveShadow = true
  bottom.position.set(0, -8, 0)
  bottom.rotation.set(0, THREE.Math.degToRad(45), 0)
  this.mesh.add(bottom)
}

export const BasicFit = function() {
  const geo = new THREE.TorusGeometry(3, 5, 13, 120, 6.3)
  geo.applyMatrix(new THREE.Matrix4().makeRotationY(-Math.PI / 2))
  const mat = new THREE.MeshPhongMaterial({
    color: 0x5e6166,
    flatShading: true
  })

  this.mesh = new THREE.Mesh(geo, mat)
  this.mesh.castShadow = true
  this.mesh.receiveShadow = true

  const other = new THREE.Mesh(geo, mat)
  other.position.set(30, 0, 0)
  other.castShadow = true
  other.receiveShadow = true
  this.mesh.add(other)

  const geoCylinder = new THREE.CylinderGeometry(2, 2, 30, 40)
  geoCylinder.applyMatrix(new THREE.Matrix4().makeRotationZ(-Math.PI / 2))
  const cylinder = new THREE.Mesh(geoCylinder, mat)
  cylinder.position.set(10, 0, 0)
  cylinder.castShadow = true
  cylinder.receiveShadow = true
  this.mesh.add(cylinder)
}

export const AirPlane = function() {
  this.mesh = new THREE.Object3D()

  const geomCockpit = new THREE.BoxGeometry(80, 50, 50, 1, 1, 1)
  const matCockpit = new THREE.MeshPhongMaterial({
    color: 0x00a1e4,
    flatShading: true
  })
  geomCockpit.vertices[4].y -= 10
  geomCockpit.vertices[4].z += 20
  geomCockpit.vertices[5].y -= 10
  geomCockpit.vertices[5].z -= 20
  geomCockpit.vertices[6].y += 30
  geomCockpit.vertices[6].z += 20
  geomCockpit.vertices[7].y += 30
  geomCockpit.vertices[7].z -= 20
  const cockpit = new THREE.Mesh(geomCockpit, matCockpit)
  cockpit.castShadow = true
  cockpit.receiveShadow = true
  this.mesh.add(cockpit)

  const geomEngine = new THREE.BoxGeometry(20, 50, 50, 1, 1, 1)
  const matEngine = new THREE.MeshPhongMaterial({
    color: 0xffffff,
    flatShading: true
  })
  const engine = new THREE.Mesh(geomEngine, matEngine)
  engine.position.x = 40
  engine.castShadow = true
  engine.receiveShadow = true
  this.mesh.add(engine)

  const geomTailPlane = new THREE.BoxGeometry(15, 20, 5, 1, 1, 1)
  const matTailPlane = new THREE.MeshPhongMaterial({
    color: 0x00a1e4,
    flatShading: true
  })
  const tailPlane = new THREE.Mesh(geomTailPlane, matTailPlane)
  tailPlane.position.set(-35, 25, 0)
  tailPlane.castShadow = true
  tailPlane.receiveShadow = true
  this.mesh.add(tailPlane)

  const geomSideWing = new THREE.BoxGeometry(40, 4, 150, 1, 1, 1)
  const matSideWing = new THREE.MeshPhongMaterial({
    color: 0x00a1e4,
    flatShading: true
  })

  const sideWingTop = new THREE.Mesh(geomSideWing, matSideWing)
  const sideWingBottom = new THREE.Mesh(geomSideWing, matSideWing)
  sideWingTop.castShadow = true
  sideWingTop.receiveShadow = true
  sideWingBottom.castShadow = true
  sideWingBottom.receiveShadow = true

  sideWingTop.position.set(20, 12, 0)
  sideWingBottom.position.set(20, -3, 0)
  this.mesh.add(sideWingTop)
  this.mesh.add(sideWingBottom)

  const geomWindshield = new THREE.BoxGeometry(3, 15, 20, 1, 1, 1)
  const matWindshield = new THREE.MeshPhongMaterial({
    color: 0xffffff,
    transparent: true,
    opacity: 0.3,
    flatShading: true
  })
  const windshield = new THREE.Mesh(geomWindshield, matWindshield)
  windshield.position.set(5, 27, 0)

  windshield.castShadow = true
  windshield.receiveShadow = true

  this.mesh.add(windshield)

  const geomPropeller = new THREE.BoxGeometry(20, 10, 10, 1, 1, 1)
  geomPropeller.vertices[4].y -= 5
  geomPropeller.vertices[4].z += 5
  geomPropeller.vertices[5].y -= 5
  geomPropeller.vertices[5].z -= 5
  geomPropeller.vertices[6].y += 5
  geomPropeller.vertices[6].z += 5
  geomPropeller.vertices[7].y += 5
  geomPropeller.vertices[7].z -= 5
  const matPropeller = new THREE.MeshPhongMaterial({
    color: 0x5e6166,
    flatShading: true
  })
  this.propeller = new THREE.Mesh(geomPropeller, matPropeller)
  this.propeller.castShadow = true
  this.propeller.receiveShadow = true

  const geomBlade1 = new THREE.BoxGeometry(1, 100, 10, 1, 1, 1)
  const geomBlade2 = new THREE.BoxGeometry(1, 10, 100, 1, 1, 1)
  const matBlade = new THREE.MeshPhongMaterial({
    color: 0x5e6166,
    flatShading: true
  })

  const blade1 = new THREE.Mesh(geomBlade1, matBlade)
  blade1.position.set(8, 0, 0)
  blade1.castShadow = true
  blade1.receiveShadow = true

  const blade2 = new THREE.Mesh(geomBlade2, matBlade)
  blade2.position.set(8, 0, 0)
  blade2.castShadow = true
  blade2.receiveShadow = true
  this.propeller.add(blade1, blade2)
  this.propeller.position.set(50, 0, 0)
  this.mesh.add(this.propeller)

  const wheelProtecGeom = new THREE.BoxGeometry(30, 15, 10, 1, 1, 1)
  const wheelProtecMat = new THREE.MeshPhongMaterial({
    color: 0xffffff,
    flatShading: true
  })
  const wheelProtecR = new THREE.Mesh(wheelProtecGeom, wheelProtecMat)
  wheelProtecR.position.set(25, -20, 25)
  this.mesh.add(wheelProtecR)

  const wheelTireGeom = new THREE.BoxGeometry(24, 24, 4)
  const wheelTireMat = new THREE.MeshPhongMaterial({
    color: 0x5e6166,
    flatShading: true
  })
  const wheelTireR = new THREE.Mesh(wheelTireGeom, wheelTireMat)
  wheelTireR.position.set(25, -28, 25)

  const wheelAxisGeom = new THREE.BoxGeometry(10, 10, 6)
  const wheelAxisMat = new THREE.MeshPhongMaterial({
    color: 0x5e6166,
    flatShading: true
  })
  const wheelAxis = new THREE.Mesh(wheelAxisGeom, wheelAxisMat)
  wheelTireR.add(wheelAxis)

  this.mesh.add(wheelTireR)

  const wheelProtecL = wheelProtecR.clone()
  wheelProtecL.position.z = -wheelProtecR.position.z
  this.mesh.add(wheelProtecL)

  const wheelTireL = wheelTireR.clone()
  wheelTireL.position.z = -wheelTireR.position.z
  this.mesh.add(wheelTireL)

  const wheelTireB = wheelTireR.clone()
  wheelTireB.scale.set(0.5, 0.5, 0.5)
  wheelTireB.position.set(-35, -5, 0)
  this.mesh.add(wheelTireB)

  const suspensionGeom = new THREE.BoxGeometry(4, 20, 4)
  suspensionGeom.applyMatrix(new THREE.Matrix4().makeTranslation(0, 10, 0))
  const suspensionMat = new THREE.MeshPhongMaterial({
    color: 0x00a1e4,
    flatShading: true
  })
  const suspension = new THREE.Mesh(suspensionGeom, suspensionMat)
  suspension.position.set(-35, -5, 0)
  suspension.rotation.z = -0.3
  this.mesh.add(suspension)
}

export const Ajax = function() {
  const material = new THREE.MeshBasicMaterial({
    color: 0x000000,
    side: THREE.DoubleSide,
    transparent: true,
    opacity: 0.9
  })

  let sideLength, a, b, c, d, e, f, g, h, cords, lineWidth

  sideLength = 50
  lineWidth = 2

  a = 0.0
  b = 1.0
  c = 2.0
  d = (1.0 + Math.sqrt(5.0)) / 2.0
  e = 3.0 * d
  f = 1.0 + 2.0 * d
  g = 2.0 + d
  h = 2.0 * d

  a *= sideLength
  b *= sideLength
  c *= sideLength
  d *= sideLength
  e *= sideLength
  f *= sideLength
  g *= sideLength
  h *= sideLength

  cords = [
    [+a, +b, +e],
    [+a, +b, -e],
    [+a, -b, +e],
    [+a, -b, -e],

    [+b, +e, +a],
    [+b, -e, +a],
    [-b, +e, +a],
    [-b, -e, +a],

    [+e, +a, +b],
    [-e, +a, +b],
    [+e, +a, -b],
    [-e, +a, -b],

    [+c, +f, +d],
    [+c, +f, -d],
    [+c, -f, +d],
    [-c, +f, +d],
    [+c, -f, -d],
    [-c, +f, -d],
    [-c, -f, +d],
    [-c, -f, -d],

    [+f, +d, +c],
    [+f, -d, +c],
    [-f, +d, +c],
    [+f, +d, -c],
    [-f, -d, +c],
    [+f, -d, -c],
    [-f, +d, -c],
    [-f, -d, -c],
    [+d, +c, +f],
    [-d, +c, +f],
    [+d, +c, -f],
    [+d, -c, +f],
    [-d, +c, -f],
    [-d, -c, +f],
    [+d, -c, -f],
    [-d, -c, -f],

    [+b, +g, +h],
    [+b, +g, -h],
    [+b, -g, +h],
    [-b, +g, +h],
    [+b, -g, -h],
    [-b, +g, -h],
    [-b, -g, +h],
    [-b, -g, -h],

    [+g, +h, +b],
    [+g, -h, +b],
    [-g, +h, +b],
    [+g, +h, -b],
    [-g, -h, +b],
    [+g, -h, -b],
    [-g, +h, -b],
    [-g, -h, -b],

    [+h, +b, +g],
    [-h, +b, +g],
    [+h, +b, -g],
    [+h, -b, +g],
    [-h, +b, -g],
    [-h, -b, +g],
    [+h, -b, -g],
    [-h, -b, -g]
  ]

  this.mesh = new THREE.Object3D()
  let footballEdge

  var p0 = new THREE.Vector3(0, 0, 0)
  var radius = new THREE.Vector3(
    cords[0][0],
    cords[0][1],
    cords[0][2]
  ).distanceTo(p0)

  footballEdge = new THREE.Object3D()
  footballEdge.position.z = radius / 7

  footballEdge.add(
    new THREE.Mesh(
      new THREE.TorusBufferGeometry(radius, lineWidth, 8, 128),
      material
    )
  )

  for (var i = 0; i < cords.length; ++i) {
    for (var j = 0; j < cords.length; ++j) {
      if (i === j) continue

      var p1, p2, p3, distance, mid

      p1 = new THREE.Vector3(cords[i][0], cords[i][1], cords[i][2])
      p2 = new THREE.Vector3(cords[j][0], cords[j][1], cords[j][2])

      distance = p1.distanceTo(p2)

      if (Math.round(distance) > c) continue

      mid = new THREE.Vector3(
        (cords[i][0] + cords[j][0]) / 2,
        (cords[i][1] + cords[j][1]) / 2,
        (cords[i][2] + cords[j][2]) / 2
      )

      var scale = p1.distanceTo(p0) / mid.distanceTo(p0)
      p3 = new THREE.Vector3(
        mid.x * scale * scale,
        mid.y * scale * scale,
        mid.z * scale * scale
      )

      var curve = new THREE.QuadraticBezierCurve3(p1, p3, p2)

      var tubeGeom = new THREE.TubeGeometry(curve, 8, lineWidth, 4, false)

      this.mesh.add(new THREE.Mesh(tubeGeom, material))
    }
  }

  var facesCords = [
    [0, 28, 36, 39, 29],
    [1, 32, 41, 37, 30],
    [2, 33, 42, 38, 31],
    [3, 34, 40, 43, 35],
    [4, 12, 44, 47, 13],
    [5, 16, 49, 45, 14],
    [6, 17, 50, 46, 15],
    [7, 18, 48, 51, 19],
    [8, 20, 52, 55, 21],
    [9, 24, 57, 53, 22],
    [10, 25, 58, 54, 23],
    [11, 26, 56, 59, 27]
  ]

  var indicesOfFaces = []

  for (let i = 0; i < facesCords.length; ++i) {
    var faceCord = facesCords[i]
    for (let j = 0; j < faceCord.length - 2; ++j) {
      indicesOfFaces.push(faceCord[0])
      indicesOfFaces.push(faceCord[j + 1])
      indicesOfFaces.push(faceCord[j + 2])
    }
  }

  var facesGeom = new THREE.PolyhedronBufferGeometry(
    flattenDeep(cords),
    indicesOfFaces,
    radius,
    2
  )

  this.mesh.add(new THREE.Mesh(facesGeom, material))
}

export const Polaroid = function() {
  const geo = new THREE.PlaneGeometry(10, 120, 30)
  const mat = new THREE.MeshBasicMaterial({ color: 0xffffff })
  this.mesh = new THREE.Mesh(geo, mat)
  this.mesh.receiveShadow = true
  this.mesh.castShadow = true

  const side = new THREE.Mesh(geo, mat)
  side.position.set(-110, 0, 0)
  this.mesh.add(side)

  const top = new THREE.Mesh(geo, mat)
  top.rotation.set(0, 0, THREE.Math.degToRad(90))
  top.position.set(-55, 55, 0)
  this.mesh.add(top)

  const geoEnd = new THREE.PlaneGeometry(30, 120, 30)
  const end = new THREE.Mesh(geoEnd, mat)
  end.rotation.set(0, 0, THREE.Math.degToRad(90))
  end.position.set(-55, -55, 0)
  this.mesh.add(end)
}

// eslint-disable-next-line flowtype/require-parameter-type
export const FireWorks = function(scene) {
  this.scene = scene
  this.done = false
  this.dest = []
  this.colors = []
  this.geometry = null
  this.points = null
  this.material = new THREE.PointsMaterial({
    size: 1.01,
    color: 0xffffff,
    opacity: 1,
    vertexColors: true,
    transparent: true,
    depthTest: false
  })
  this.reset = () => {
    this.scene.remove(this.points)
    this.dest = []
    this.colors = []
    this.geometry = null
    this.points = null
  }
  this.launch = () => {
    const from = new THREE.Vector3(0, -600, -100)
    const to = new THREE.Vector3(0, 500, -100)

    const color = new THREE.Color()
    color.setHSL(THREE.Math.randFloat(0.1, 0.9), 1, 0.9)
    this.colors.push(color)

    this.geometry = new THREE.Geometry()
    this.points = new THREE.Points(this.geometry, this.material)

    this.geometry.colors = this.colors
    this.geometry.vertices.push(from)
    this.dest.push(to)
    this.colors.push(color)
    this.scene.add(this.points)
  }
  this.explode = vector => {
    this.scene.remove(this.points)
    this.dest = []
    this.colors = []
    this.geometry = new THREE.Geometry()
    this.points = new THREE.Points(this.geometry, this.material)

    for (var i = 0; i < 80; i++) {
      var color = new THREE.Color()
      color.setHSL(THREE.Math.randFloat(0.1, 0.9), 1, 0.5)
      this.colors.push(color)

      var from = new THREE.Vector3(
        THREE.Math.randInt(vector.x - 10, vector.x + 10),
        THREE.Math.randInt(vector.y - 10, vector.y + 10),
        THREE.Math.randInt(vector.z - 10, vector.z + 10)
      )
      var to = new THREE.Vector3(
        THREE.Math.randInt(vector.x - 1000, vector.x + 1000),
        THREE.Math.randInt(vector.y - 1000, vector.y + 1000),
        THREE.Math.randInt(vector.z - 1000, vector.z + 1000)
      )
      this.geometry.vertices.push(from)
      this.dest.push(to)
    }
    this.geometry.colors = this.colors
    this.scene.add(this.points)
  }
  this.update = () => {
    if (this.points && this.geometry) {
      var total = this.geometry.vertices.length

      // lerp particle positions
      for (var i = 0; i < total; i++) {
        this.geometry.vertices[i].x +=
          (this.dest[i].x - this.geometry.vertices[i].x) / 20
        this.geometry.vertices[i].y +=
          (this.dest[i].y - this.geometry.vertices[i].y) / 20
        this.geometry.vertices[i].z +=
          (this.dest[i].z - this.geometry.vertices[i].z) / 20
        this.geometry.verticesNeedUpdate = true
      }
      // watch first particle for explosion
      if (total === 1) {
        if (Math.ceil(this.geometry.vertices[0].y) > this.dest[0].y - 20) {
          this.explode(this.geometry.vertices[0])
          return
        }
      }
      // fade out exploded particles
      if (total > 1) {
        this.material.opacity -= 0.015
        this.material.colorsNeedUpdate = true
      }
      // remove, reset and stop animating
      if (this.material.opacity <= 0) {
        this.reset()
        this.done = true
      }
    }
  }
  this.launch()
}

export const Snowman = function() {
  const geo = new THREE.IcosahedronGeometry(10, 1)
  const mat = new THREE.MeshPhongMaterial({
    color: 0xffffff,
    emissive: 0xf66120,
    specular: 0xffed22,
    shininess: 10,
    flatShading: true,
    transparent: 1,
    opacity: 1
  })
  this.mesh = new THREE.Mesh(geo, mat)
  this.mesh.receiveShadow = true
  this.mesh.castShadow = true

  const geo1 = new THREE.IcosahedronGeometry(8, 1)
  const geo2 = new THREE.IcosahedronGeometry(7, 1)

  const body = new THREE.Mesh(geo1, mat)
  body.position.y += 12
  body.receiveShadow = true
  body.castShadow = true
  this.mesh.add(body)

  const head = new THREE.Mesh(geo2, mat)
  head.position.y += 22
  head.receiveShadow = true
  head.castShadow = true

  const noseMat = new THREE.MeshBasicMaterial({ color: 0xffa000 })
  const noseGeo = new THREE.ConeBufferGeometry(1, 4, 32)
  const nose = new THREE.Mesh(noseGeo, noseMat)
  nose.rotation.set(THREE.Math.degToRad(90), 0, 0)
  nose.position.set(0, 1, 9)
  nose.receiveShadow = true
  nose.castShadow = true

  const eyeMat = new THREE.MeshBasicMaterial({ color: 0x000000 })
  const eyeGeo = new THREE.IcosahedronGeometry(0.5, 1)
  const eye = new THREE.Mesh(eyeGeo, eyeMat)
  eye.position.set(2, 3, 7)

  const secondEye = eye.clone()
  secondEye.position.set(-2, 3, 7)

  head.add(nose, eye, secondEye)

  this.mesh.add(head)
}

export const Bell = function() {
  const geo = new THREE.IcosahedronGeometry(10, 1)
  const mat = new THREE.MeshPhongMaterial({
    color: 0x795da3,
    emissive: 0xf66120,
    specular: 0xffed22,
    shininess: 10,
    flatShading: true,
    transparent: 1,
    opacity: 1
  })
  this.mesh = new THREE.Mesh(geo, mat)
  this.mesh.receiveShadow = true
  this.mesh.castShadow = true
  const shapeOne = new THREE.Mesh(
    new THREE.CylinderGeometry((4, 6, 10, 6, 3), 0.5),
    new THREE.MeshStandardMaterial({
      color: 0xa3a1a1,
      flatShading: true,
      metalness: 0,
      roughness: 0.8,
      refractionRatio: 0.25
    })
  )
  shapeOne.position.y += 9
  shapeOne.castShadow = true
  shapeOne.receiveShadow = true
  this.mesh.add(shapeOne)

  const shapeTwo = new THREE.Mesh(
    new THREE.TorusGeometry((2, 1, 6, 4, 2), 0.6),
    new THREE.MeshStandardMaterial({
      color: 0xa3a1a1,
      flatShading: true,
      metalness: 0,
      roughness: 0.8,
      refractionRatio: 0.25
    })
  )
  shapeTwo.position.y += 9.5
  shapeTwo.castShadow = true
  shapeTwo.receiveShadow = true
  this.mesh.add(shapeTwo)
}

export const BigTree = function() {
  const material = new THREE.MeshBasicMaterial({ color: 0x00300d })
  this.mesh = new THREE.Mesh(new THREE.ConeGeometry(7, 10, 64), material)
  this.mesh.receiveShadow = true
  this.mesh.castShadow = true

  const treeLayer = new THREE.Mesh(new THREE.ConeGeometry(10, 12, 64), material)
  treeLayer.position.y = -5
  this.mesh.add(treeLayer)

  const treeLayerFinal = new THREE.Mesh(
    new THREE.ConeGeometry(13, 18, 64),
    material
  )
  treeLayerFinal.position.y = -10
  this.mesh.add(treeLayerFinal)

  for (var i = 0; i < 3; i++) {
    bell.push(new Bell())
    bell[i].mesh.scale.set(0.15, 0.15, 0.15)
    this.mesh.add(bell[i].mesh)
  }
  bell[0].mesh.position.set(1.5, -2, 4.5)
  bell[1].mesh.position.set(-3, -6.5, 6)
  bell[2].mesh.position.set(5, -10, 7.5)
}

export const Globe = function() {
  // bottom globe
  this.mesh = new THREE.Mesh(
    new THREE.CylinderGeometry(50, 50, 15, 32),
    new THREE.MeshStandardMaterial({
      color: 0xa3a1a1,
      flatShading: true,
      metalness: 0,
      roughness: 0.8,
      refractionRatio: 0.25
    })
  )
  this.mesh.receiveShadow = true
  this.mesh.castShadow = true

  // trees
  const tr = new Tree()
  tr.mesh.position.set(15, 9, 15)
  this.mesh.add(tr.mesh)

  const tree1 = new Tree()
  tree1.mesh.position.set(-10, 9, -15)
  this.mesh.add(tree1.mesh)

  // snow
  for (let i = 0; i < 80; i++) {
    const lumiereS = new THREE.MeshPhongMaterial({
      emissive: '#fff'
    })
    snow.push(
      new THREE.Mesh(
        new THREE.SphereGeometry(Math.random() * 1, 50, 50),
        lumiereS
      )
    )
  }
  for (let i = 0; i < snow.length; i++) {
    snow[i].position.set(
      Math.random() * 50 - 10,
      Math.random() * 80,
      Math.random() * 40 - 10
    )
    this.mesh.add(snow[i])
  }

  // glass globe
  const geo = new THREE.IcosahedronGeometry(55, 3)
  const mat = new THREE.MeshPhongMaterial({
    color: 0x795da3,
    emissive: 0xf66120,
    specular: 0xffed22,
    shininess: 10,
    flatShading: true,
    transparent: 1,
    opacity: 0.3
  })
  const boll = new THREE.Mesh(geo, mat)
  boll.position.y = +35
  this.mesh.add(boll)
}

export const Palm = function() {
  const extrudeSettings = {
    steps: 1,
    depth: 0.005,
    bevelEnabled: true,
    bevelThickness: 0.025,
    bevelSize: 0.5,
    bevelSegments: 0.5
  }

  const leafShape = new THREE.Shape()
  leafShape.quadraticCurveTo(0, 5.5, 10, 5.5)
  leafShape.quadraticCurveTo(0, -5.5, 0, 2)

  const geometryLeaf = new THREE.ExtrudeGeometry(leafShape, extrudeSettings)

  var geometry = new THREE.BoxGeometry(0.35, 1.5, 0.25)
  geometry.translate(0, 0.5, 0)
  var material = new THREE.MeshBasicMaterial({
    color: 0x00300d,
    transparent: true,
    opacity: 0
  })
  this.mesh = new THREE.Mesh(geometry, material)
  this.mesh.castShadow = true
  this.mesh.receiveShadow = true

  var geometry1 = new THREE.CylinderGeometry(0.35, 0.45, 0.5, 6)
  var materialBase = new THREE.MeshToonMaterial({ color: 0x3f0000 })
  var palmBase = new THREE.Mesh(geometry1, materialBase)
  this.mesh.add(palmBase)

  var geometry2 = new THREE.CylinderGeometry(0.2, 0.3, 0.5, 6)
  var palmBase1 = new THREE.Mesh(geometry2, materialBase)
  palmBase1.position.set(-0.025, 0.45, 0.0)
  palmBase1.rotation.set(0, 0, 0.15)
  this.mesh.add(palmBase1)

  var geometry3 = new THREE.CylinderGeometry(0.05, 0.2, 0.5, 6)
  var palmBase3 = new THREE.Mesh(geometry3, materialBase)
  palmBase3.position.set(-0.15, 0.85, 0.0)
  palmBase3.rotation.set(0, 0, 0.35)
  this.mesh.add(palmBase3)

  var geometry4 = new THREE.CylinderGeometry(0.015, 0.04, 0.25, 6)
  var palmTrunkTop = new THREE.Mesh(geometry4, materialBase)
  palmTrunkTop.position.set(-0.28, 1.15, 0.025)
  palmTrunkTop.rotation.set(0.25, 0.5, 0.5)
  this.mesh.add(palmTrunkTop)

  var materialLeaf = new THREE.MeshToonMaterial({ color: 0x00300d })
  var Leaf = new THREE.Mesh(geometryLeaf, materialLeaf)
  Leaf.scale.set(0.085, 0.085, 1)
  Leaf.position.set(-1.05, 0.5, 0)
  Leaf.rotation.set(18.5, 2.5, 2)
  this.mesh.add(Leaf)

  let pL = Leaf.clone()
  pL.position.set(0.3, 1.9, 0.15)
  pL.rotation.set(8.8, 0.5, 2)
  this.mesh.add(pL)

  let pL1 = Leaf.clone()
  pL1.position.set(0.1, 0.8, 1.05)
  pL1.rotation.set(-0.85, -3.5, 0.5)
  this.mesh.add(pL1)
}

export const Tree = function() {
  const geometryCube = new THREE.BoxGeometry(3, 3, 3)
  const materialCube = new THREE.MeshBasicMaterial({ color: 0x3f0000 })
  this.mesh = new THREE.Mesh(geometryCube, materialCube)
  this.mesh.castShadow = true
  this.mesh.receiveShadow = true

  const treeGeo = new THREE.ConeBufferGeometry(5, 20, 32)
  const treeMat = new THREE.MeshPhongMaterial({
    color: 0x00300d,
    emissive: 0x00300d,
    specular: 0x00300d,
    shininess: 1,
    flatShading: true,
    transparent: 1,
    opacity: 1
  })
  const cone = new THREE.Mesh(treeGeo, treeMat)
  cone.position.set(0, 11, 0)
  cone.castShadow = true
  cone.receiveShadow = true
  this.mesh.add(cone)
}

// eslint-disable-next-line flowtype/require-parameter-type
export const Image = function(image) {
  const loader = new THREE.TextureLoader()
  const imageMat = new THREE.MeshLambertMaterial({
    map: loader.load(image)
  })
  const imageGeo = new THREE.PlaneGeometry(20 * 0.75, 20, 1)
  this.mesh = new THREE.Mesh(imageGeo, imageMat)
  this.mesh.castShadow = true
  this.mesh.receiveShadow = true
}



// WEBPACK FOOTER //
// ./src/constants/three.js